import { Form, Select, type SelectProps } from "antd";
import React, { useEffect, useMemo } from "react";
import { type FormInstance, type Rule } from "antd/es/form";
import { type FilterFunc } from "rc-select/lib/Select";
import { type DefaultOptionType } from "antd/es/cascader";
import {
	type Turbine,
	type UserLimitedList,
} from "../../generated-axios-client";
import type { IntlShape } from "@formatjs/intl";
import { useWatch } from "antd/es/form/Form";

const turbineSelectOptions = (turbineItems: Array<Turbine>) => {
	const turbineOptions = turbineItems.map((item) => ({
		key: item.id,
		value: item.id,
		label: item.serial_number,
	}));

	return turbineOptions;
};

const turbineSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
	const search = input.toLowerCase();
	const value = option?.label?.toString().toLowerCase?.() ?? "";

	return value.includes(search);
};

type TurbineSelectFormItemProps = {
	intl: IntlShape;
	turbineItems?: Array<Turbine>;
	rules?: Rule[];
	placeholder?: string | boolean;
	selectProps?: SelectProps<string>;
	form: FormInstance;
};

export const TurbineSelectorFormItem = (props: TurbineSelectFormItemProps) => {
	const {
		intl,
		turbineItems,
		rules = [],
		placeholder = false,
		selectProps,
		form,
	} = props;

	const options = useMemo(
		() => turbineSelectOptions(turbineItems ?? []),
		[turbineItems],
	);

	useEffect(() => {
		if (
			options.filter((item) => {
				return item.key === form.getFieldValue("turbine");
			}).length <= 0
		) {
			form.setFieldValue("turbine", undefined);
		}
	}, [options, form]);

	const isClientSelected = useWatch(["client"], form);

	return (
		<Form.Item
			name="turbine"
			label={intl.formatMessage({ id: "filter_label_turbine" })}
			rules={[
				{
					required: true,
					message: intl.formatMessage({
						id: "validation_message_ticket_turbine",
					}),
				},
			]}
		>
			<Select
				allowClear={true}
				disabled={!isClientSelected}
				placeholder={placeholder}
				showSearch={true}
				options={options}
				filterOption={turbineSearchHandler}
				{...selectProps}
			/>
		</Form.Item>
	);
};
